// extracted by mini-css-extract-plugin
export default {"news_group_title":"index_news_group_title_Mtkq7","block":"index_block_uZQSw","link_title":"index_link_title_qYEd9","more":"index_more_6XwwH"};